import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import Product from "@/pages/Product";
import Cart from "@/pages/Cart";
import Success from "@/pages/Success";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Orders from "@/pages/Orders";
import Merchant from "@/pages/Merchant";
import SellerSignup from "@/pages/SellerSignup";
import Admin from "@/pages/Admin";
import BuyerDashboard from "@/pages/BuyerDashboard";
import Notifications from "@/pages/Notifications";
import PaymentResult from "@/pages/PaymentResult";

function App() {
  useEffect(() => {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", "ar");
    document.title = "كزيوني — سوق الجملة من تاجر لتاجر";
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/product/:id" element={<Product />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/success" element={<Success />} />
              <Route path="/auth" element={<Auth />} />
              <Route path="/account" element={<Account />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/merchant" element={<Merchant />} />
              <Route path="/seller-signup" element={<SellerSignup />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/dashboard" element={<BuyerDashboard />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/payment/success" element={<PaymentResult />} />
              <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors toastOptions={{ style: { fontFamily: "Tajawal, sans-serif", direction: "rtl" } }} />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
